import React, { useState } from 'react'

import { VideoPlayerContainer } from './_videoPlayerStyles'
import MusicPlayer from './MusicPlayer'
import SettingsPopout from './SettingsPopout'
import useVideoTracking from './useVideoTracking'
import { useVideoPlayerContext } from './VideoPlayerContext'
import { Notification } from 'components_v2/Home/SignedIn/common/components'

const VideoPlayerLayout = (props) => {
  const { videoRef, videoPlayer, state } = useVideoPlayerContext()
  const [subscriptionEndTime, setSubscriptionEndTime] = useState('')

  // We only track videos that have a planEntryId (so, not intro videos, etc.)
  useVideoTracking({ setSubscriptionEndTime })

  return (
    <>
      <VideoPlayerContainer showSettings={state.showSettings}>
        <div data-vjs-player>
          <video
            ref={videoRef}
            className='video-js'
            preload='auto'
            {...props}
          ></video>

          {state.resolutions.length > 0 && <SettingsPopout />}

          {videoPlayer && <MusicPlayer />}
        </div>
      </VideoPlayerContainer>
      {subscriptionEndTime && (
        <Notification
          id={'Notify'}
          mainText={`Success! Your free trial has been extended. Your payment will now begin on ${subscriptionEndTime}.`}
          ctaText={'VIEW MEMBERSHIP SETTINGS'}
          ctaLink={'/settings/membership'}
          onLearnMoreClick={() => setSubscriptionEndTime('')}
        />
      )}
    </>
  )
}

export default VideoPlayerLayout
